import React from "react"
import ActionButton from "./actionbutton.component"
import { FormattedMessage } from "react-intl"
import { ButtonProps } from "../types/button"
export const AddButton = (props: ButtonProps) => {
    return (
        <span className={"pr-2 m-0"}>
            <ActionButton
                disabled={props.disabled ?? false}
                className={"btn btn-primary" + (props.className ?? "")}
                onClick={props.onClickCallback}
            >
                <FormattedMessage
                    id="common.button.add"
                    defaultMessage="Add"
                />
            </ActionButton>
        </span>
    )
}


// WEBPACK FOOTER //
// ./src/common/button/AddButton.tsx